import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { BranchCategoryModel } from 'common/models/page-models/branch-category/branch-category-data.model';
import { BranchCategoryListingModel, BranchCategoryGridPostParams } from 'common/models/page-models/branch-category/branch-category-grid.model';



@Injectable({
    providedIn: 'root'
})
export class BranchCategoryGridDataService extends GridDataService<BranchCategoryListingModel, BranchCategoryModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getBranchCategoryList, http, ss);
    }

    createInstance(): BranchCategoryListingModel {
        return new BranchCategoryListingModel();
    }

    override getDeleteUrl(): string {
        return environment.apiUrl+API_URL.deleteBranchCategory;
    }

    override getGridParams(param): GridPostParams {
        return new BranchCategoryGridPostParams();
    }
}
